export const navHeight = '64px'
export const navBannerHeightDesktop = '50px'
export const navBannerHeightMobile = '64px'
